import ITask from '../../../Utility/Task/ITask';
import CardSystem from '../CardSystem';
import { UIActions } from '../../../State/UI/UIActions';
import { PopupID } from '../../../State/UI/PopupID';

export default class LevelCompleteMenuTask implements ITask<CardSystem> {
    public *execute(system: CardSystem): IterableIterator<number> {
        UIActions.showPopup(PopupID.LEVEL_COMPLETE_POPUP, {});
    }
}
